import {
    ENVIRONMENT_VARIABLE_KEY_DBXLURL,
    ENVIRONMENT_VARIABLE_KEY_DBXLUSERKEY,
} from '../../constants/environmentVariable.constants';

export const ENVIRONMENT_VARIABLE_TOKEN_PREFIX = '{fvEnvironmentVariable:';
export const ENVIRONMENT_VARIABLE_TOKEN_SUFFIX = '}';

export const makeVariableToken = (variableName) =>
    `${ENVIRONMENT_VARIABLE_TOKEN_PREFIX}${variableName}${ENVIRONMENT_VARIABLE_TOKEN_SUFFIX}`;

export const DBXL_URL_VARIABLE_TOKEN = makeVariableToken(
    ENVIRONMENT_VARIABLE_KEY_DBXLURL,
);
export const DBXL_USER_KEY_VARIABLE_TOKEN = makeVariableToken(
    ENVIRONMENT_VARIABLE_KEY_DBXLUSERKEY,
);
